import React, { Component } from 'react';
import injectSheet from 'react-jss';
import { setSessionIdToUrl, SET_ONBOARDING_MODE, history, extensionSMOnboardingDone } from 'h-commons';
import { connect } from 'react-redux';
import { Button, Box } from "@hiver/hiver-ui-kit";
import { isOnboardingChecklistEnabled, sendMessageToParentWindow, setUserPropertyActionCreator, isOnboardingJourney30DaysAvailable } from '..';

function detectBrowser() {
    var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
    if(isChrome) return 'chrome';
    if(isSafari) return 'safari';
    return 'chrome';
}

class PostOnboardingScreen extends Component{
    
    setExtensionInstalled = () => {
        const { type, email, smid } = this.props.onboarding;
        this.props.setOnboarding({ extensionInstalled: true, type, email, smid });
    }
    goToGmail = (skipGmail, showOnboardingPlgGuiders = false) => {
        const { smid } = this.props.onboarding;
        const { userSession, userDetails, setUserProperties } = this.props;
        if (skipGmail !== true) {
            window.open('https://mail.google.com', '_blank');
        }  
        extensionSMOnboardingDone(smid, showOnboardingPlgGuiders);
        history.push(setSessionIdToUrl('/app/sharedmailbox', userSession));
        this.props.unsetOnboarding();  
        const onboardingChecklistEnabled = isOnboardingChecklistEnabled(userDetails?.availableFeatures);
        if(onboardingChecklistEnabled && !userDetails?.userProperties?.create_sm_step_completed){
            const extraParams = {
                params : { 
                    checklistStep:{
                        sharedInboxCreated:true,
                    },
                    isChecklistOpen:true
                }
            }
            setUserProperties({property:'create_sm_step_completed',value:"true"});
            sendMessageToParentWindow('checklistState',extraParams);

        }      
    }
    installExtension = () => {
        const browserType = detectBrowser();
        if (browserType === 'chrome') {
            window.open('https://chrome.google.com/webstore/detail/fcinnggknmdfkilogcndkgpojpfojeem', '_blank');
            this.setExtensionInstalled();
        } else if (browserType === 'safari') {
            window.open('https://hiverhq.com/extensions/safari/Hiver.safariextz', '_blank');
            this.setExtensionInstalled();
        }
    }
    viewOnboardingPlgGuiders = () => {
        // we want to skip gmail and show onboarding plg guiders.
        const { gmailMode } = this.props;   
        const skipGmail = gmailMode
        const showOnboardingPlgGuiders = true
        this.goToGmail(skipGmail, showOnboardingPlgGuiders)
    }
    render() {
        const { classes, onboarding, userDetails, gmailMode } = this.props;    
        const { extensionInstalled, type, email } = onboarding || {};
        const buttonText = extensionInstalled ? 'Go To Gmail' : 'Install Hiver Extension';
        let action = extensionInstalled ? this.goToGmail : this.installExtension;
        const isOjEnabled = isOnboardingJourney30DaysAvailable(userDetails?.availableFeatures)
        if (gmailMode) {
            action = () => this.goToGmail(true);
        }
        return (
            <div className={`h-flexbox--vertical h-flexbox--vc ${classes.root}`}>
                <div className="h-mt-13p h-mb-13p">
                    <img className={classes.img} src={require('../images/smsetupdone.png').default} />
                </div>
                <div className={classes.title + ' h-h2'}>Your shared mailbox is ready for use!</div>
                <div className="h-mt-13p h-mb-13p h-flexbox--vertical h-flexbox--vc">
                    {isOjEnabled && extensionInstalled && <Button 
                        onClick={this.viewOnboardingPlgGuiders} 
                        sx={{fontSize: '0.875rem', marginBottom:'8px'}}
                        color="tertiary"
                    >
                        Setup Goals
                    </Button>}
                    <Box>
                        <Button
                            onClick={action}
                            sx={{ fontSize: '14px' }}
                            color="tertiary"
                            variant={isOjEnabled ? 'text': 'contained' }
                        >
                            {buttonText}
                        </Button>
                    </Box>
                </div>
                
                {
                    type === 'group' && (
                        <div className="h-mt-13p h-mb-13p">
                            <div className="h-s2">Ensure that emails sent to <b>{email}</b> should get forwarded to <b>{userDetails.emailId}</b>.</div>                    
                        </div>
                    )
                }
                { !extensionInstalled && (
                        <div className="h-mt-13p h-mb-13p">
                            <div className="h-s2">You need to install the chrome browser extension to use Hiver Shared Mailboxes.</div>
                        </div>
                    )
                }
                { !extensionInstalled && <div className="h-mt-13p h-mb-13p h-flexbox--vertical h-flexbox--sb-vc">
                        <div className="h-s3 h-mb-13p">or</div>
                        <div onClick={() => this.goToGmail(true)} className={`${classes.link} h-s3 h-mt-6p`}>Skip this, I'll do this later</div>
                    </div>
                }
            </div>
        );
    }
}

const style = {
    root: {
        paddingRight: 75
    },
    img: {
        height: 200,
        width: 200
    },
    title: {
        fontSize: '18px',
        marginTop: 35
    },
    link: {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
}

const mapStateToProps = ({ appModes: { onboarding, gmailMode, userSession }, userDetails }) => ({
    onboarding,
    userDetails,
    gmailMode,
    userSession
});

const mapDispatchToProps = (dispatch) => ({
    unsetOnboarding: () => {
        dispatch({ type: SET_ONBOARDING_MODE, payload: null });
    },
    setOnboarding: (payload) => dispatch({ type: SET_ONBOARDING_MODE, payload }),
    setUserProperties : ({property,value})=>dispatch(setUserPropertyActionCreator({property,value}))
});

const StyledPostOnboardingScreen = connect(mapStateToProps, mapDispatchToProps)(injectSheet(style)(PostOnboardingScreen));

export { StyledPostOnboardingScreen as  PostOnboardingScreen};